const CheckoutHeaderSkeleton = () => (
  <div className="flex items-end justify-between">
    <div className="h-10 w-48 animate-pulse rounded bg-gray-100" />
    <div className="flex gap-8">
      <div className="h-5 w-20 animate-pulse rounded bg-gray-100" />
      <div className="h-5 w-10 animate-pulse rounded bg-gray-100" />
      <div className="h-5 w-32 animate-pulse rounded bg-gray-100" />
    </div>
  </div>
);

const CheckoutItemSkeleton = () => (
  <div className="flex gap-4">
    <div className="h-28 w-28 animate-pulse rounded bg-gray-100" />
    <div className="h-10 w-full animate-pulse rounded bg-gray-100" />
  </div>
);

const CheckoutPriceSkeleton = () => (
  <div className="flex flex-col items-end gap-2">
    <div className="h-5 w-60 animate-pulse rounded bg-gray-100" />
    <div className="h-5 w-80 animate-pulse rounded bg-gray-100" />
    <div className="h-5 w-40 animate-pulse rounded bg-gray-100" />
  </div>
);

const CheckoutFooterSkeleton = () => (
  <div className="mt-10 flex gap-4 max-lg:flex-col">
    <div className="h-20 w-full animate-pulse rounded bg-gray-100" />
    <div className="h-20 w-full animate-pulse rounded bg-gray-100" />
  </div>
);

const CheckoutSkeleton = () => (
  <div className="my-10 flex flex-col gap-4 px-4">
    <CheckoutHeaderSkeleton />
    <CheckoutItemSkeleton />
    <CheckoutPriceSkeleton />
    <CheckoutFooterSkeleton />
  </div>
);

CheckoutSkeleton.displayName = "CheckoutSkeleton";

export default CheckoutSkeleton;
